import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

const routes = [
    {
        path: '/',
        redirect: {
            name: 'home'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/menus/register/index'),
        meta: {
            title: '注册'
        }
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('../views/menus/home'),
        meta: {
            title: '首页',
            login: true
        }
    },
    {
        path: '/study',
        name: 'study',
        component: () => import('../views/menus/study/index'),
        meta: {
            title: '学习',
            login: true
        }
    },
    {
        path: '/study/searchIndex',
        name: 'study/searchIndex',
        component: () => import('../views/menus/study/searchIndex'),
        meta: {
            title: '搜索',
            login: true
        }
    },
    {
        path: '/study/vedioDetails',
        name: 'study/vedioDetails',
        component: () => import('../views/menus/study/vedioDetails'),
        meta: {
            title: '视频详情',
            login: true
        }
    },
    {
        path: '/study/fileDetails',
        name: 'study/fileDetails',
        component: () => import('../views/menus/study/fileDetails'),
        meta: {
            title: '文件详情',
            login: true
        }
    },
    {
        path: '/practice',
        name: 'practice',
        component: () => import('../views/menus/practice/index'),
        meta: {
            title: '刷题',
            login: true
        }
    },
    {
        path: '/myExam',
        name: 'myExam',
        component: () => import('../views/menus/exam/index'),
        meta: {
            title: '考试',
            login: true
        }
    },
    {
        path: '/myExam/prompt',
        name: 'examPrompt',
        component: () => import('../views/menus/exam/prompt'),
        meta: {
            title: '考试提示',
            login: true
        }
    },
    {
        path: '/myExam/examResult',
        name: 'exam/examResult',
        component: () => import('../views/menus/exam/examResult'),
        meta: {
            title: '考试详情',
            login: true
        }
    },
    {
        path: '/practice/everyDay',
        name: 'practice/everyDay',
        component: () => import('../views/menus/practice/everyDay/index'),
        meta: {
            title: '每日一练',
            login: true
        }
    },
    {
        path: '/practice/myPractice',
        name: 'practice/myPractice',
        component: () => import('../views/menus/practice/myPractice/index'),
        meta: {
            title: '自练自查',
            login: true
        }
    },
    {
        path: '/me',
        name: 'me',
        component: () => import('../views/menus/Me/index'),
        meta: {
            title: '我的资料',
            login: true
        }
    },
    {
        path: '/me/myIndex',
        name: 'me/myIndex',
        component: () => import('../views/menus/Me/myIndex'),
        meta: {
            title: '个人中心',
            login: true
        }
    },
    {
        path: '/me/updatePassword',
        name: 'me/updatePassword',
        component: () => import('../views/menus/Me/updatePassword'),
        meta: {
            title: '修改密码',
            login: true
        }
    },
    {
        path: '/answerQuestions',
        name: 'answerQuestions',
        component: () => import('../views/menus/answerQuestions/index'),
        meta: {
            title: '答题',
            login: true
        }
    },
    {
        path: '/wrongAnswer',
        name: 'wrongAnswer',
        component: () => import('../views/menus/answerQuestions/wrongIndex'),
        meta: {
            title: '错题纠正',
            login: true
        }
    },
    {
        path: '/complete',
        name: 'complete',
        component: () => import('../views/menus/answerQuestions/complete'),
        meta: {
            title: '完成',
            login: true
        }
    },
    {
        path: '/practice/practiceResult',
        name: 'practice/practiceResult',
        component: () => import('../views/menus/practice/practiceResult'),
        meta: {
            title: '练习详情',
            login: true
        }
    },
    {
        path: '/speechToText',
        name: 'speechToText',
        component: () => import('../views/menus/study/speechToText'),
        meta: {
            title: 'speechToText',
            login: true
        }
    },
    {
        path: '/pdfView',
        name: 'pdfView',
        component: () => import('../views/menus/study/pdfView'),
        meta: {
            title: 'pdfView',
            login: true
        }
    },
    
    
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {
    if (to.meta.title) document.title = to.meta.title;

    if (to.meta.login) {
        if (store.getters['user/isLogin']()) {
            next();
        } else {
            next({
                path: '/login'
            });
        }
    }else if (to.name === 'register') {
        // 明确允许访问注册页
        next();
    }else {
        // 检查用户是否已经登录并且尝试访问登录页面
        if (to.name === 'login' && store.getters['user/isLogin']()) {
            next({
                name: 'home'
            });
        } else {
            next();
        }
    }
});

router.afterEach(() => {
    scrollTo(0, 0);
});

export default router;